import 'react-fancybox/lib/fancybox.css';
import './styles.scss';

import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Chip, Menu, MenuItem } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import Switch from '@mui/material/Switch';
import axios from 'axios';
import Hashids from 'hashids';
import React, { useCallback, useEffect, useState } from 'react';
import SweetAlert from 'react-bootstrap-sweetalert';
import BootstrapTable from 'react-bootstrap-table-next';
import cellEditFactory, { Type } from 'react-bootstrap-table2-editor';
import paginationFactory, {
  PaginationProvider,
  PaginationTotalStandalone,
  SizePerPageDropdownStandalone,
} from 'react-bootstrap-table2-paginator';
import ToolkitProvider from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit';
import { isMobile } from 'react-device-detect';
import { TfiUnlink } from 'react-icons/tfi';
import Lightbox from 'react-image-lightbox';
import { connect } from 'react-redux';
import {
  Link,
  useLocation,
  useNavigate,
  useSearchParams,
} from 'react-router-dom';
import AsyncSelect from 'react-select/async';
import AsyncCreatableSelect from 'react-select/async-creatable';
import { toast as Toast } from 'react-toastify';
import { Button, Modal } from 'reactstrap';
import { v4 as uuidv4 } from 'uuid';

import CigarMerger from '@/components/cigars/merger';
import Breadcrumb from '@/components/common/breadcrumb.component';
import MediaCropper from '@/components/cropper';
import DebounceSearchBar from '@/components/debounce-search-bar';
import Icon from '@/components/icon';
import NoDataIndicator from '@/components/no-data-indicator';
import StandalonePagination from '@/components/pagination/standalone';
import RowMoreOptions from '@/components/table/row-more-options';
import TableLoader from '@/components/table-loader';
import ToastContent from '@/components/toasts/content';
import { Constants } from '@/constants';
import {
  getAllCigars,
  getBinders,
  getCigarById,
  getDuplicateCigars,
  getFillers,
  getManufacturers,
  getOrigins,
  getWrappers,
  searchCigars,
  updateVitolas,
} from '@/redux/actions/cigar.actions';
import { getBrands, postCigar, putCigar } from '@/utils/actions/cigar';
import { uploadToS3 } from '@/utils/imageUtils';

const hashids = new Hashids('', 12);

const defaultSorted = [
  {
    dataField: 'brand',
    order: 'asc',
  },
];

const cellEditProps = {
  mode: 'dbclick',
  beforeSaveCell(
    oldValue: any,
    newValue: any,
    row: any,
    column: any,
    done: any
  ) {
    console.log(`Before save for ${column.dataField}`);
    // TODO: call done() on success or done(false) on failure
  },
  afterSaveCell: (oldValue: any, newValue: any, row: any, column: any) => {
    console.log(`After save for ${column}`);
  },
};

const strengths = ['Mellow', 'Mellow-Medium', 'Medium', 'Medium-Full', 'Full'];

const defaults = {
  // FIXME Remove these unnecessary fields - they got moved to the editor
  selectedId: null,
  selectedName: '',
  selectedManufacturer: '',
  selectedOrigin: '',
  selectedWrapper: '',
  selectedBinder: '',
  selectedFiller: '',
  selectedStrength: '',
  selectedTags: '',
  selectedVitolas: [],
  strengths: [
    { value: 1, label: 'Mellow' },
    { value: 2, label: 'Mellow-Medium' },
    { value: 3, label: 'Medium' },
    { value: 4, label: 'Medium-Full' },
    { value: 5, label: 'Full' },
  ],
  mergeCigar: '',
  vitolas: [
    {
      alias: { value: '', label: '' },
      shape: { value: '', label: '' },
      gauge: { value: '', label: '' },
      length: { value: '', label: '' },
    },
  ],
  similarCigars: [{ value: '', label: '' }],
  cigarImageFull: null,
  cigarImageBand: null,
  cigarImageFoot: null,
  cigarImageDisplay: null,
  selectedFacebook: false,
  selectedInstagram: false,
  selectedTwitter: false,
  showUrlTooltip: false,
  showMergeTooltip: false,
  showImportModal: false,
  showMediaCropper: false,
  importVitolasOnly: false,
  merging: false,
  selectedUrl: '',
  openLightbox: false,
  photoIndex: -1,
  selectedForceMerge: false,
  activeDropzone: null,
  activeDropzoneId: null,
  cigarImportType: 'single_import',
  dialogModal: {
    show: false,
    title: '',
    text: '',
  },
};

interface Option {
  value: string;
  label: string;
}

const CigarTable: React.FC<any> = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();

  const [displayStyle, setDisplayStyle] = useState(isMobile ? 'grid' : 'table');

  const [showLightbox, setShowLightbox] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [showBrandPicker, setShowBrandPicker] = useState(false);
  const [selectedBrandName, setSelectedBrandName] = useState<string | null>(
    null
  );
  const [selectedBrand, setSelectedBrand] = useState<any | null>(null);

  // Use one state object to mimic this.state
  const [state, setState] = useState<any>({
    cigars: [],
    page: 1,
    sizePerPage: 30,
    showCigarModal: false,
    showMergeModal: false,
    showVitolaModal: false,
    showVitolasModal: false,
    showSocialModal: false,
    showPagePickerModal: false,
    cigarImageView: 'all',
    message: { type: 'info', show: false, title: '', text: '' },
    ...defaults,
  });

  const updateState = (newState: any) =>
    setState((prev: any) => ({ ...prev, ...newState }));

  const pageParam = Number(searchParams.get('page') ?? state.page);
  const hasQ = searchParams.has('q');
  const qParam = searchParams.get('q') ?? '';
  const hasId = searchParams.has('id');
  const idParam = searchParams.get('id') ?? '';

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout> | null = null;

    if (isMobile) {
      props.getAllCigars(pageParam, state.sizePerPage);
    }

    if (hasQ) {
      timer = setTimeout(() => {
        if (qParam !== state.searchText) {
          updateState({ searchText: qParam });
          handleTableChange(state.tableChangeType, {
            page: pageParam,
            sizePerPage: state.sizePerPage,
            searchText: qParam,
          });
        }
      }, 250);
    }

    if (!hasQ && searchParams.has('page')) {
      if (state.showPossibleDuplicates) {
        props.getDuplicateCigars(pageParam, state.sizePerPage);
      } else {
        props.getAllCigars(pageParam, state.sizePerPage);
      }
    }

    if (hasId) {
      let cigarId = parseInt(idParam, 10);
      if (Number.isNaN(cigarId)) {
        cigarId = hashids.decode(idParam)[0] as number;
      }
      if (cigarId) {
        props.getCigarById(cigarId);
      }
    }

    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [
    isMobile,
    searchParams.toString(),
    state.page,
    state.sizePerPage,
    state.showPossibleDuplicates,
    state.tableChangeType,
    state.searchText,
  ]);

  useEffect(() => {
    let { cigars } = props.CigarManager;
    if (!cigars) return;

    if (!Array.isArray(cigars)) {
      cigars = [cigars];
    }
    updateState({ cigars });
  }, [props.CigarManager.cigars]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);

    if (state.searchText) {
      params.set('q', state.searchText);
      navigate(`${location.pathname}?${params}`);
    } else {
      params.delete('q');
      navigate(location.pathname);
    }
  }, [state.searchText, location.pathname, navigate]);

  const keyForType = (type: string) => {
    switch (type) {
      case 'cigar':
        return 'showCigarModal';
      case 'merge':
        return 'showMergeModal';
      case 'vitola':
        return 'showVitolaModal';
      case 'vitolas':
        return 'showVitolasModal';
      case 'vitolaImage':
        return 'showVitolaImageModal';
      case 'social':
        return 'showSocialModal';
      case 'import':
        return 'showImportModal';
      case 'page':
        return 'showPagePickerModal';
      case 'datatable':
        return 'showImporterDatatable';
      default:
        return '';
    }
  };

  const onOpenModal = (type: string, row?: any) => {
    if (type === 'cigar' && row) {
      console.log(JSON.stringify(row));
      let wrappers: any = '';
      if (row.wrapper) {
        if (typeof row.wrapper === 'string') {
          row.wrapper = row.wrapper.split(', ');
        }
        wrappers = row.wrapper.map((wrapper: string) => ({
          value: wrapper,
          label: wrapper,
        }));
      }
      let binders: any = '';
      if (row.binder) {
        if (typeof row.binder === 'string') {
          row.binder = row.binder.split(', ');
        }
        binders = row.binder.map((binder: string) => ({
          value: binder,
          label: binder,
        }));
      }
      let fillers: any = '';
      if (row.filler) {
        if (typeof row.filler === 'string') {
          row.filler = row.filler.split(', ');
        }
        fillers = row.filler.map((filler: string) => ({
          value: filler,
          label: filler,
        }));
      }

      let cigarImageFull = null;
      let cigarImageBand = null;
      let cigarImageFoot = null;
      let cigarImageDisplay = null;
      if (row.images) {
        for (let i = 0; i < row.images.length; i++) {
          const image = row.images[i];
          if (image.approved) {
            if (image.image_type === 0) {
              cigarImageFull = image.image_url;
            } else if (image.image_type === 1) {
              cigarImageBand = image.image_url;
            } else if (image.image_type === 5) {
              cigarImageFoot = image.image_url;
            } else if (image.image_type === 6) {
              cigarImageDisplay = image.image_url;
            }
          }
        }
      }
      updateState({
        selectedId: row.id || null,
        // selectedBrand: row.brand ? { value: row.brand, label: row.brand } : '',
        selectedName: row.name || '',
        selectedManufacturer: row.manufacturer
          ? { value: row.manufacturer, label: row.manufacturer }
          : '',
        selectedOrigin: row.origin
          ? { value: row.origin, label: row.origin }
          : '',
        selectedWrapper: wrappers,
        selectedBinder: binders,
        selectedFiller: fillers,
        selectedStrength: row.strength
          ? { value: row.strength, label: strengths[row.strength - 1] }
          : '',
        selectedTags: row.tags
          ? row.tags.map((cigarTag: any) => ({
              value: cigarTag.tag.title,
              label: cigarTag.tag.title,
            }))
          : [],
        selectedVitolas: row.vitolas
          ? row.vitolas.map((vitola: any) => ({
              ...vitola,
              select_shape: { value: vitola.shape, label: vitola.shape },
            }))
          : [],
        cigarImageFull: cigarImageFull || null,
        cigarImageBand: cigarImageBand || null,
        cigarImageFoot: cigarImageFoot || null,
        cigarImageDisplay: cigarImageDisplay || null,
      });
    } else if (type === 'social') {
      setTimeout(() => {
        updateState({
          message: {
            type: 'info',
            show: true,
            title: 'Under Development',
            text: "This feature isn't available yet.",
          },
        });
      }, 300);
    } else if (type === 'merge' && row && row.id) {
      updateState({ selectedCigar: row, selectedId: row.id });
    }
    updateState({ [keyForType(type)]: true });
  };

  const onCloseModal = (type: string) => {
    if (type === 'cigar') {
      updateState({ [keyForType(type)]: false, ...defaults });
    } else {
      updateState({ [keyForType(type)]: false });
    }
  };

  const onSaveModal = (type: string) => {
    console.debug('Saving... ', type);
    if (type === 'cigar') {
      const {
        selectedWrapper,
        selectedBinder,
        selectedFiller,
        selectedTags,
        selectedName,
        selectedManufacturer,
        selectedOrigin,
        selectedStrength,
        selectedId,
        selectedVitolas,
      } = state;

      // Build arrays from selected options
      const wrappers = selectedWrapper?.length
        ? selectedWrapper.map((sw: any) => sw.value)
        : [];
      const binders = selectedBinder?.length
        ? selectedBinder.map((sb: any) => sb.value)
        : [];
      const fillers = selectedFiller?.length
        ? selectedFiller.map((sf: any) => sf.value)
        : [];
      const tags = selectedTags?.length
        ? selectedTags.map((st: any) => st.value)
        : [];

      const brandIdValue = selectedBrand?.value;
      const brandId =
        brandIdValue != null && brandIdValue !== ''
          ? Number(brandIdValue)
          : NaN;
      const cigar = {
        brand: selectedBrand.label,
        brand_id: Number.isInteger(brandId) ? brandId : undefined,
        name: selectedName,
        affiliate: selectedManufacturer.value,
        origin: selectedOrigin.value,
        wrapper: wrappers.join(', '),
        filler: fillers.join(', '),
        binder: binders.join(', '),
        strength: selectedStrength.value,
        tags,
        vitolas: selectedVitolas,
        pending: false,
        custom: false,
        cuban: selectedOrigin.value === 'Cuba',
      };

      // Remove empty strings (if needed)
      Object.keys(cigar).forEach(function (key) {
        if (cigar[key] === '') {
          cigar[key] = null;
        }
      });

      if (selectedId) {
        cigar.id = selectedId;
        putCigar(cigar)
          .then((updatedCigar: any) => {
            Toast.success(
              <ToastContent
                message="Cigar updated successfully"
                title={updatedCigar.full_name}
              />,
              {
                position: 'top-right',
              }
            );
            updateState({ [keyForType(type)]: false, ...defaults });
            handleRowChange(updatedCigar);
          })
          .catch((err: any) => {
            updateState({
              message: {
                show: true,
                type: 'error',
                title: 'Uh oh!',
                text: 'Unable to update the cigar details. Please contact an admin.',
              },
            });
          });
        // Optionally update media and vitolas here...
      } else {
        postCigar(cigar)
          .then((updatedCigar: any) => {
            Toast.success(
              <ToastContent
                message="Cigar added successfully"
                title={updatedCigar.full_name}
              />,
              {
                position: 'top-right',
              }
            );
            // Optionally update media here...
            updateState({ [keyForType(type)]: false, ...defaults });
            handleRowChange(updatedCigar);
          })
          .catch((err: any) => {
            updateState({
              message: {
                show: true,
                type: 'error',
                title: 'Uh oh!',
                text: 'Unable to add the cigar details. Please contact an admin.',
              },
            });
          });
      }
    } else if (type === 'vitola' || type === 'vitolas') {
      onCloseModal(type);
    } else if (type === 'filter') {
      if (state.showPossibleDuplicates) {
        props.getDuplicateCigars(1, state.sizePerPage || 10);
      } else {
        const pendingStatus =
          state.pendingStatus === 'pending' ||
          state.pendingStatus === 'approved'
            ? state.pendingStatus
            : undefined;
        props.getAllCigars(
          1,
          state.sizePerPage || 10,
          undefined,
          pendingStatus
        );
      }
      updateState({
        showFilterDrawer: false,
        anchorEl: null,
        showMoreMenu: false,
      });
      setDisplayStyle(state.displayStyle || 'table');
    }
  };

  const activeFormatter = (pending: any, cigar: any) => (
    <span>
      <Switch
        checked={!pending}
        onChange={(e) => {
          cigar.pending = !e.target.checked;
          putCigar(cigar).then((updatedCigar) => {
            handleRowChange(updatedCigar);
          });
        }}
        color="secondary"
      />
    </span>
  );

  const brandFormatter = (cell: any, row: any) => {
    if (row.brand_id) {
      return (
        <Link to={`/brands/editor/${hashids.encode(row.brand_id)}`}>
          {cell}
        </Link>
      );
    }
    return (
      <span
        style={{ color: '#dc3545', cursor: 'pointer' }}
        onClick={() => {
          updateState({ selectedCigar: row });
          setSelectedBrandName(cell);
          setShowBrandPicker(true);
        }}
      >
        {cell} <TfiUnlink />
      </span>
    );
  };

  const imageFormatter = (cell: any, row: any) => {
    const cigar = row;

    if (state.cigarImageView === 'all') {
      const validImageTypes = [0, 1, 6];
      const filteredImages =
        cigar.images?.filter(
          (image: any) =>
            validImageTypes.includes(image.image_type) &&
            image.approved === true
        ) || [];

      const sortedImages = filteredImages.sort(
        (a: any, b: any) => a.image_type - b.image_type
      );

      return (
        <div style={{ display: 'flex' }}>
          {sortedImages.length > 0
            ? sortedImages.map((image: any, index: number) => (
                <div
                  key={index}
                  className="react-fancybox"
                  onClick={() => {
                    setSelectedImage(image.image_url);
                    setShowLightbox(true);
                  }}
                  style={{ marginLeft: index > 0 ? 10 : 0 }}
                >
                  <div className="thumbnail thumbnail-sm">
                    <img alt="" src={image.image_url} />
                  </div>
                </div>
              ))
            : null}
        </div>
      );
    }

    const imageTypes = {
      band: 0,
      full: 1,
      display: 6,
    };
    const imageType = imageTypes[state.cigarImageView];
    let cigarImage;
    if (cigar.images && cigar.images.length > 0) {
      for (let i = 0; i < cigar.images.length; i++) {
        if (
          cigar.images[i].image_type === imageType &&
          cigar.images[i].approved === true
        ) {
          cigarImage = cigar.images[i].image_url;
          break;
        }
      }
    }
    return cigarImage ? (
      <div
        className="react-fancybox"
        onClick={() => {
          setSelectedImage(cigarImage);
          setShowLightbox(true);
        }}
      >
        <div className="thumbnail">
          <img alt="" src={cigarImage} />
        </div>
      </div>
    ) : null;
  };

  const handleRadioChange =
    (key: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
      updateState({ [key]: event.target.value });
    };

  const handleSelectChange = (key: string) => (value: any) => {
    updateState({ [key]: value });
  };

  // const handlePageChange = (e: any, index: number) => {
  //   updateState({ page: index });
  //   const { sizePerPage, searchText, pendingStatus } = state;
  //   const ps =
  //     pendingStatus === 'pending' || pendingStatus === 'approved'
  //       ? pendingStatus
  //       : undefined;
  //   props.getAllCigars(index + 1, sizePerPage, searchText && searchText.length > 0 ? searchText : null, ps);
  // };

  const handlePageChange = (page, sizePerPage) => {
    updateState({ page, sizePerPage });

    const params = new URLSearchParams(location.search);
    params.set('page', page);

    navigate(`${location.pathname}?${params.toString()}`);
  };

  const editBtnFormatter = (cell: any, row: any, index: number) => (
    <div style={{ minWidth: 68 }}>
      <div id={`dropdown-actions-${index}`} className="dropdown-actions d-none">
        <Icon
          name="edit2"
          className="ml-1 mr-3"
          style={{
            cursor: 'pointer',
            display: 'inline',
            height: 18,
            width: 18,
          }}
          onClick={() => {
            const cigar = row;
            navigate(
              `/cigars/editor/${cigar.hash_id || hashids.encode(cigar.id)}`,
              { state: { cigar } }
            );
          }}
        />
        {actionDropdown(index, row)}
      </div>
    </div>
  );

  const updateRecords = () => {
    const { page, sizePerPage, searchText, tableChangeType } = state;
    handleTableChange(tableChangeType, {
      page: page - 1 > 0 ? page - 1 : 1,
      sizePerPage,
      searchText,
    });
    setTimeout(() => {
      handleTableChange(tableChangeType, { page, sizePerPage, searchText });
    }, 50);
  };

  const handleRowChange = (updatedCigar: any) => {
    const updatedCigars = state.cigars.map((cigar: any) =>
      cigar.id === updatedCigar.id ? { ...cigar, ...updatedCigar } : cigar
    );
    updateState({ cigars: updatedCigars });
    updateRecords();
  };

  const handleRowDelete = (deletedCigar: any) => {
    const updatedCigars = state.cigars.filter(
      (cigar: any) => cigar.id !== deletedCigar.id
    );
    updateState({ cigars: updatedCigars });
  };

  const handleTableChange = (
    type: any,
    {
      page,
      sizePerPage,
      filters,
      sortField,
      sortOrder,
      cellEdit,
      searchText,
    }: any
  ) => {
    if (!searchParams?.has('id')) {
      const pendingStatus =
        state.pendingStatus === 'pending' || state.pendingStatus === 'approved'
          ? state.pendingStatus
          : undefined;
      if (state.showPossibleDuplicates) {
        props.getDuplicateCigars(page, sizePerPage);
      } else {
        props.getAllCigars(
          page,
          sizePerPage,
          searchText && searchText.length > 0 ? searchText : null,
          pendingStatus
        );
      }
      updateState({ tableChangeType: type, page, sizePerPage, searchText });
    }
  };

  const closeAlert = () => {
    updateState({ message: { show: false, title: '', text: '' } });
  };

  const deleteCigar = () => {
    updateState({
      dialogModal: {
        show: true,
        title: 'Are you sure you want to delete?',
        text: 'This will delete the cigar and all vitolas and cannot be undone. Note: If users have this cigar associated with a smoke session or review, this will return an error. In that case, you will need to merge the cigar instead.',
      },
    });
  };

  const deleteCigarConfirmed = () => {
    updateState({
      message: {
        type: 'info',
        show: true,
        title: 'Under Development',
        text: "This feature isn't available yet. In the meantime, consider merging the cigar into a corresponding one.",
      },
    });
  };

  const actionDropdown = (index: number, cigar: any) => (
    <RowMoreOptions
      row={index}
      items={[
        {
          type: 'MenuItem',
          onClick: () => onOpenModal('social', cigar),
          title: 'Create social media post',
        },
        {
          type: 'Divider',
        },
        {
          type: 'MenuItem',
          onClick: () =>
            navigate(
              `/cigars/vitolas/manager?cigar_id=${cigar.hash_id}&filter=${cigar.full_name}`
            ),
          title: 'Manage Vitolas',
        },
        {
          type: 'MenuItem',
          onClick: () => {
            navigate('/cigars/editor/new', {
              state: {
                cigar: {
                  ...cigar,
                  vitolas:
                    cigar.vitolas &&
                    cigar.vitolas.map((vitola: any) => ({
                      ...vitola,
                      id: null,
                    })),
                  images: [],
                  id: null,
                },
              },
            });
          },
          title: 'Duplicate',
        },
        {
          type: 'MenuItem',
          onClick: () => {
            axios
              .post(
                `${Constants.apiPath}/actions/cigars/${cigar.id}/search/index`
              )
              .then(() => {
                Toast.success(
                  <ToastContent
                    message="Successfully re-indexed"
                    title={cigar.full_name}
                  />,
                  {
                    position: 'top-right',
                  }
                );
              });
          },
          title: 'Re-index in Search',
        },
        {
          type: 'MenuItem',
          onClick: () => {
            Promise.all([
              axios.post(
                `${Constants.apiPath}/actions/cigars/${cigar.id}/images/index`
              ),
              axios.post(
                `${Constants.apiPath}/actions/cigars/${cigar.id}/images/tests`
              ),
            ]).then(() => {
              Toast.success(
                <ToastContent
                  message="Successfully added images to training model"
                  title={cigar.full_name}
                />,
                {
                  position: 'top-right',
                }
              );
            });
          },
          title: 'Add to recognition model',
        },
        {
          type: 'Divider',
        },
        {
          type: 'MenuItem',
          onClick: () =>
            updateState({ selectedCigar: cigar, showMergeModal: true }),
          title: 'Merge',
        },
        {
          type: 'MenuItem',
          onClick: () => deleteCigar(),
          style: { color: '#ff4700' },
          title: 'Delete',
        },
      ]}
      onShow={() => {
        const dropdownActions = document.querySelector(
          `#dropdown-actions-${index}`
        );
        if (dropdownActions) {
          dropdownActions.classList.add('d-none');
        }
      }}
    />
  );

  const uploadMedia = (blob: any, extension: string, type: string) => {
    const uuid = uuidv4();
    const cigarHash = hashids.encode(
      state.selectedCigar ? state.selectedCigar.id : new Date().getTime()
    );
    const filename = `${cigarHash}-${type}.${extension}`;
    uploadToS3(blob, `cigars/${type}`, filename, uuid)
      .then((res) => {
        updateState({ uploadingMedia: false, [type]: res.data.media_url });
      })
      .catch((err) => {
        updateState({ uploadingMedia: false });
        console.error(err);
      });
  };

  const renderMediaCropper = () => {
    const {
      selectedImageFile,
      showMediaCropper,
      activeDropzone,
      activeDropzoneId,
    } = state;
    return (
      <MediaCropper
        aspectRatio={activeDropzoneId === 'cigarImageDisplay' ? 1 : undefined}
        src={selectedImageFile}
        open={showMediaCropper}
        toggle={() => updateState({ showMediaCropper: !showMediaCropper })}
        onClose={() => updateState({ showMediaCropper: false })}
        onSave={(croppedCanvas: any) => {
          const base64 = croppedCanvas.toDataURL('image/jpeg');
          updateState({ showMediaCropper: false, selectedImage: base64 });
          croppedCanvas.toBlob((blob: any) => {
            const fileReader = new FileReader();
            fileReader.onload = (event: any) => {
              const dataUrl = event.target.result;
              const { dropzone } = activeDropzone;
              dropzone.emit('addedfile', blob);
              dropzone.emit('thumbnail', blob, dataUrl);
              dropzone.emit('complete', blob);
              dropzone.files.push(blob);
            };
            fileReader.readAsDataURL(blob);
            uploadMedia(
              blob,
              base64.split(';')[0].split('/')[1],
              activeDropzoneId
            );
          });
        }}
      />
    );
  };

  const resetFilters = () => {
    alert('Reset coming soon! Please refresh your browser to reset.');
  };

  const renderFilterOptions = () => (
    <SwipeableDrawer
      anchor="right"
      open={state.showFilterDrawer}
      onClose={() => updateState({ showFilterDrawer: false })}
    >
      <div
        style={{
          width: isMobile ? 'calc(100vw - 40px)' : 300,
          marginLeft: 20,
          marginRight: 20,
          marginBottom: 30,
        }}
      >
        <div style={{ height: 20 }} />
        <FormLabel component="legend">Filter By Brand</FormLabel>
        <div
          className="select-wrapper"
          style={{ maxWidth: 'calc(100% - 40px)' }}
        >
          <AsyncSelect
            value={selectedBrand || { label: 'All Brands', value: -1 }}
            onChange={handleSelectChange('selectedBrand')}
            // loadOptions={}
            defaultOptions={[{ label: 'All Brands', value: -1 }]}
            isOptionSelected={(option: any) => selectedBrand === option}
          />
        </div>
        <FormLabel component="legend" style={{ marginTop: 12 }}>
          Filter By Status
        </FormLabel>
        <RadioGroup
          row
          aria-label="approval status"
          name="approval-status"
          value={state.pendingStatus || 'all'}
          onChange={handleRadioChange('pendingStatus')}
        >
          <FormControlLabel
            value="all"
            control={<Radio color="primary" />}
            label="All"
            labelPlacement="end"
          />
          <FormControlLabel
            value="approved"
            control={<Radio color="primary" />}
            label="Approved"
            labelPlacement="end"
          />
          <FormControlLabel
            value="pending"
            control={<Radio color="primary" />}
            label="Pending"
            labelPlacement="end"
          />
        </RadioGroup>
        <FormLabel component="legend">Data Display Style</FormLabel>
        <RadioGroup
          row
          aria-label="data view style"
          name="display-style"
          value={state.displayStyle || 'table'}
          onChange={(e) => {
            updateState({
              displayStyle: e.target.value,
            });
          }}
        >
          <FormControlLabel
            value="table"
            control={<Radio color="primary" />}
            label="Table"
            labelPlacement="end"
          />
          <FormControlLabel
            value="grid"
            control={<Radio color="primary" />}
            label="Grid"
            labelPlacement="end"
          />
        </RadioGroup>
        <FormLabel component="legend">Image View Style</FormLabel>
        <RadioGroup
          row
          aria-label="image view style"
          name="image-style"
          value={state.cigarImageView || 'band'}
          onChange={(e) => {
            updateState({
              cigarImageView: e.target.value,
            });
          }}
        >
          <FormControlLabel
            value="band"
            control={<Radio color="primary" />}
            label="Band (On Cigar)"
            labelPlacement="end"
          />
          <FormControlLabel
            value="full"
            control={<Radio color="primary" />}
            label="Band (Full)"
            labelPlacement="end"
          />
          <FormControlLabel
            value="display"
            control={<Radio color="primary" />}
            label="Display"
            labelPlacement="end"
          />
          <FormControlLabel
            value="all"
            control={<Radio color="primary" />}
            label="All"
            labelPlacement="end"
          />
        </RadioGroup>
        <FormLabel component="legend" style={{ marginTop: 12 }}>
          Filter By Issue
        </FormLabel>
        <div>
          <FormControlLabel
            control={
              <Checkbox
                checked={state.showMissingImages}
                onChange={(e) => {
                  updateState({
                    showMissingImages: e.target.checked,
                  });
                }}
                inputProps={{ 'aria-label': 'Missing images' }}
              />
            }
            label="Missing images"
            disabled={state.showPossibleDuplicates}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={state.showMissingVitolas}
                onChange={(e) => {
                  updateState({
                    showMissingVitolas: e.target.checked,
                  });
                }}
                inputProps={{ 'aria-label': 'Missing vitolas' }}
              />
            }
            label="Missing vitolas"
            disabled={state.showPossibleDuplicates}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={state.showPossibleDuplicates}
                onChange={(e) => {
                  updateState({
                    showPossibleDuplicates: e.target.checked,
                  });
                }}
                inputProps={{ 'aria-label': 'Possible duplicates' }}
              />
            }
            label="Possible duplicates"
          />
        </div>
        <div
          style={{
            display: 'flex',
            position: 'fixed',
            bottom: 0,
            backgroundColor: 'white',
            width: 300,
            padding: '10px 0',
            margin: 'auto',
          }}
        >
          <Button
            color="light"
            onClick={() => {
              updateState({ showFilterDrawer: false });
              resetFilters();
            }}
            style={{
              display: 'block',
              flex: 1,
              marginRight: 10,
              textAlign: 'center',
            }}
          >
            Reset
          </Button>
          <Button
            variant="contained"
            color="primary"
            style={{ display: 'block', flex: 1, textAlign: 'center' }}
            onClick={() => onSaveModal('filter')}
          >
            Apply
          </Button>
        </div>
      </div>
    </SwipeableDrawer>
  );

  const columns = [
    {
      dataField: 'pending',
      text: 'Active',
      formatter: activeFormatter,
      sort: false,
    },
    {
      dataField: 'images',
      text: '',
      formatter: imageFormatter,
      sort: false,
      editable: false,
      headerClasses: 'sticky-header',
    },
    {
      dataField: 'brand',
      text: 'Brand',
      formatter: brandFormatter,
      sort: true,
      headerClasses: 'sticky-header',
    },
    {
      dataField: 'name',
      text: 'Name',
      sort: true,
      headerClasses: 'sticky-header',
    },
    {
      dataField: 'origin',
      text: 'Origin',
      sort: true,
      headerClasses: 'sticky-header',
    },
    {
      dataField: 'wrapper',
      text: 'Wrapper',
      sort: true,
      headerClasses: 'sticky-header',
    },
    {
      dataField: 'binder',
      text: 'Binder',
      sort: true,
      headerClasses: 'sticky-header',
    },
    {
      dataField: 'filler',
      text: 'Filler',
      sort: true,
      headerClasses: 'sticky-header',
    },
    {
      dataField: 'strength',
      text: 'Strength',
      formatter: (cell: any) => strengths[cell - 1],
      editor: {
        type: Type.SELECT,
        options: [
          { value: '1', label: 'Mellow' },
          { value: '2', label: 'Mellow-Medium' },
          { value: '3', label: 'Medium' },
          { value: '4', label: 'Medium-Full' },
          { value: '5', label: 'Full' },
        ],
      },
      headerClasses: 'sticky-header',
    },
    {
      text: '',
      formatter: editBtnFormatter,
      sort: false,
      editable: false,
      headerClasses: 'sticky-header',
    },
  ];

  const selectRow = {
    mode: 'checkbox',
  };

  const rowEvents = {
    onMouseEnter: (e: any, row: any, index: number) => {
      document
        .querySelector(`#dropdown-actions-${index}`)
        ?.classList.remove('d-none');
    },
    onMouseLeave: (e: any, row: any, index: number) => {
      document
        .querySelector(`#dropdown-actions-${index}`)
        ?.classList.add('d-none');
    },
    // onDoubleClick: (e: any, row: any, index: number) => {
    //   // Double click event if needed
    // },
  };

  const pageButtonRenderer = ({ page, active, onPageChange }: any) => {
    const handleClick = (e: any) => {
      e.preventDefault();
      onPageChange(page);
    };
    const classname = active
      ? 'btn btn-secondary'
      : 'btn btn-outline-secondary';
    return (
      <li className="page-item pl-1" key={page}>
        <a href="#" onClick={handleClick} className={classname}>
          {page}
        </a>
      </li>
    );
  };

  const clearQueryParams = () => {
    navigate(location.pathname, { replace: true });
    if (state.showPossibleDuplicates) {
      props.getDuplicateCigars(state.page, state.sizePerPage);
    } else {
      props.getAllCigars(state.page, state.sizePerPage);
    }
  };

  const loadBrands = useCallback(
    async (inputValue: string): Promise<Option[]> => {
      const brands: string[] = await getBrands(inputValue);
      console.log('Received brands:', brands);
      return brands.map((brand) => ({
        value: brand.id,
        label: brand.name,
      }));
    },
    []
  );

  const renderBrandPicker = () => (
    <Modal isOpen={showBrandPicker} onClosed={() => setShowBrandPicker(false)}>
      <div className="modal-header">
        <h5 className="modal-title">{'Link Brand'}</h5>
      </div>
      <div className="modal-body">
        <AsyncCreatableSelect
          value={selectedBrand}
          defaultInputValue={selectedBrandName}
          onChange={setSelectedBrand}
          getOptionLabel={(option) => `${option.label}`}
          getOptionValue={(option) => `${option}`}
          isOptionSelected={(option) =>
            selectedBrand && selectedBrand.value === option.value
          }
          loadOptions={loadBrands}
          defaultOptions={props.CigarManager.brands.map((value) => ({
            value,
            label: value,
          }))}
        />
      </div>
      <div className="modal-footer">
        <Button onClick={() => setShowBrandPicker(false)}>Cancel</Button>
        <Button
          onClick={() => {
            const brandIdValue = selectedBrand?.value;
            const brandId =
              brandIdValue != null && brandIdValue !== ''
                ? Number(brandIdValue)
                : NaN;
            const cigar = {
              ...state.selectedCigar,
              brand: selectedBrand?.label || state.selectedCigar.brand,
              brand_id: Number.isInteger(brandId) ? brandId : undefined,
            };
            // console.log('Updating cigar:', cigar);

            putCigar(cigar).then((updatedCigar) => {
              Toast.success(
                <ToastContent
                  message="Cigar brand updated successfully"
                  title={updatedCigar.full_name}
                />,
                {
                  position: 'top-right',
                }
              );
              handleRowChange(updatedCigar);
              setShowBrandPicker(false);
            });
          }}
          variant="contained"
          color="primary"
        >
          {'Update'}
        </Button>
      </div>
    </Modal>
  );

  return (
    <div>
      <SweetAlert
        show={state.message.show}
        type={state.message.type}
        title={state.message.title}
        onConfirm={closeAlert}
      >
        {state.message.text}
      </SweetAlert>

      <Breadcrumb title="Cigar Manager" label="Manager" parent="Cigars" />

      <div className="container-fluid">
        {searchParams?.get('id') && (
          <Chip
            size="small"
            label={`id: ${searchParams?.get('id')}`}
            onClick={clearQueryParams}
            onDelete={clearQueryParams}
          />
        )}
        <div className="row">
          <div className="col-sm-12">
            <div
              className="m-b-10"
              style={
                isMobile ? { background: 'transparent', boxShadow: 'none' } : {}
              }
            >
              <div className="datatable-react">
                <ToolkitProvider
                  keyField="id"
                  data={state.cigars}
                  columns={columns}
                  search
                >
                  {(toolkitprops: any) => (
                    <div>
                      <div style={{ display: 'flex', marginTop: 20 }}>
                        {isMobile && (
                          <DebounceSearchBar
                            {...toolkitprops.searchProps}
                            placeholder="Search cigars..."
                            onChange={() => updateState({ page: 1 })}
                            onSearch={(query) => {
                              // INFO Since mobile doesn't use BootstrapTable, this needs managed manually
                              updateState({ searchText: query });
                            }}
                          />
                        )}
                        {!isMobile && (
                          <div style={{ flex: 1 }}>
                            <DebounceSearchBar
                              {...toolkitprops.searchProps}
                              value={state.searchText}
                              placeholder="Search cigars..."
                              onChange={() => updateState({ page: 1 })}
                            />
                          </div>
                        )}
                        {/* <ClearSearchButton { ...props.searchProps } /> */}
                        <button
                          className="btn btn-secondary mr-2"
                          onClick={() => {
                            navigate('/cigars/editor/new?import=true');
                          }}
                          style={isMobile ? { padding: '6px 14px' } : {}}
                        >
                          {isMobile ? (
                            <i className="icon icon-import" />
                          ) : (
                            'Import Cigar'
                          )}
                        </button>
                        <button
                          className="btn btn-primary"
                          onClick={() => navigate('/cigars/editor/new')}
                          style={isMobile ? { padding: '6px 14px' } : {}}
                        >
                          {isMobile ? (
                            <i className="icon icon-plus" />
                          ) : (
                            'Add Cigar'
                          )}
                        </button>
                        <button
                          className="btn btn-secondary"
                          onClick={(event) => {
                            updateState({
                              anchorEl: event.currentTarget,
                              showMoreMenu: true,
                            });
                          }}
                          style={{
                            // padding: '6px 14px',
                            marginLeft: '10px',
                          }}
                        >
                          <MoreVertIcon />
                        </button>
                        <Menu
                          id="demo-customized-menu"
                          MenuListProps={{
                            'aria-labelledby': 'demo-customized-button',
                          }}
                          anchorEl={state.anchorEl}
                          open={state.showMoreMenu}
                          onClose={() =>
                            updateState({
                              anchorEl: null,
                              showMoreMenu: false,
                            })
                          }
                        >
                          <MenuItem
                            disableRipple
                            onClick={() => {
                              updateState({
                                anchorEl: null,
                                showMoreMenu: false,
                                showFilterDrawer: true,
                              });
                            }}
                          >
                            Display Options
                          </MenuItem>
                          <MenuItem
                            disableRipple
                            onClick={() => {
                              updateState({
                                anchorEl: null,
                                showMoreMenu: false,
                              });
                              axios
                                .post(
                                  `${Constants.apiPath}/actions/cigars/search/index`
                                )
                                .then(() => {
                                  Toast.success(
                                    'Successfully re-indexed cigars',
                                    { position: 'top-right' }
                                  );
                                })
                                .catch((error) => {
                                  console.error(error);
                                  Toast.error('Unable to re-indexed cigars', {
                                    position: 'top-right',
                                  });
                                });
                            }}
                          >
                            Re-index All Cigars
                          </MenuItem>
                        </Menu>
                      </div>
                      {displayStyle === 'grid' ? (
                        <div>
                          {state.cigars.map((cigar: any, i: number) => {
                            let cigarImageFull = '';
                            if (cigar.images) {
                              for (let j = 0; j < cigar.images.length; j++) {
                                const image = cigar.images[j];
                                if (image.image_type === 0) {
                                  cigarImageFull = image.image_url;
                                }
                              }
                            }
                            return (
                              <div
                                key={i}
                                className="col-sm-12 col-md-6 col-lg-4 col-xl-3"
                                style={{ padding: 0, display: 'inline-block' }}
                              >
                                <div
                                  className="card height-equal"
                                  style={{
                                    margin: isMobile
                                      ? '0px -20px 20px'
                                      : '20px 15px',
                                  }}
                                >
                                  <div className="card-body native-image-bg">
                                    <span style={{ float: 'right' }}>
                                      {actionDropdown(i, cigar)}
                                    </span>
                                    <div className="row">
                                      <div className="col-4">
                                        <img
                                          src={cigarImageFull}
                                          style={{ width: '100%' }}
                                          onClick={() =>
                                            updateState({
                                              photoIndex: i,
                                              openLightbox: true,
                                            })
                                          }
                                        />
                                      </div>
                                      <div className="col-8">
                                        <h4>
                                          {cigar.brand} {cigar.name}
                                        </h4>
                                        <p>
                                          <strong>Origin:</strong>{' '}
                                          {cigar.origin}
                                        </p>
                                        <p>
                                          <strong>Wrapper:</strong>{' '}
                                          {cigar.wrapper}
                                        </p>
                                        <p>
                                          <strong>Binder:</strong>{' '}
                                          {cigar.binder}
                                        </p>
                                        <p>
                                          <strong>Filler:</strong>{' '}
                                          {cigar.filler}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    className="card-footer"
                                    style={{
                                      flexDirection: 'row',
                                      justifyContent: 'center',
                                      alignItems: 'center',
                                    }}
                                  >
                                    <button
                                      type="button"
                                      className="btn btn-primary ml-2"
                                      style={{ float: 'right' }}
                                      onClick={() => {
                                        navigate(
                                          `/cigars/editor/${cigar.hash_id || hashids.encode(cigar.id)}`,
                                          {
                                            state: { cigar },
                                          }
                                        );
                                      }}
                                    >
                                      {'Edit'}
                                    </button>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      ) : (
                        <PaginationProvider
                          pagination={paginationFactory({
                            page: state.page,
                            sizePerPage: state.sizePerPage,
                            pageButtonRenderer,
                            custom: true,
                            totalSize: props.CigarManager.totalSize,
                            showTotal: true,
                            onPageChange: handlePageChange,
                          })}
                        >
                          {({ paginationProps, paginationTableProps }: any) => (
                            <div>
                              <BootstrapTable
                                remote
                                keyField="id"
                                data={state.cigars}
                                columns={columns}
                                rowEvents={rowEvents}
                                defaultSorted={defaultSorted}
                                wrapperClasses="table-responsive"
                                {...paginationTableProps}
                                cellEdit={cellEditFactory(cellEditProps)}
                                onTableChange={handleTableChange}
                                noDataIndication={() =>
                                  !props.CigarManager.loading ? (
                                    <NoDataIndicator message="No cigars found matching search query." />
                                  ) : (
                                    <TableLoader />
                                  )
                                }
                                {...toolkitprops.baseProps}
                              />
                              <PaginationTotalStandalone {...paginationProps} />
                              <div
                                style={{
                                  width: 200,
                                  display: 'inline-block',
                                  float: 'right',
                                }}
                              />
                              <div
                                style={{ display: 'flex', paddingBottom: 20 }}
                              >
                                <div style={{ flex: 1 }}>
                                  <StandalonePagination
                                    paginationProps={paginationProps}
                                  />
                                </div>
                                <div>
                                  <SizePerPageDropdownStandalone
                                    {...paginationProps}
                                  />
                                </div>
                              </div>
                            </div>
                          )}
                        </PaginationProvider>
                      )}
                      {renderMediaCropper()}
                      {renderFilterOptions()}
                    </div>
                  )}
                </ToolkitProvider>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showLightbox && selectedImage && (
        <Lightbox
          mainSrc={selectedImage}
          onCloseRequest={() => setShowLightbox(false)}
        />
      )}
      <CigarMerger
        open={state.showMergeModal}
        sourceCigar={state.selectedCigar}
        onClose={() => updateState({ showMergeModal: false })}
        onCancel={() =>
          updateState({ selectedCigar: null, showMergeModal: false })
        }
        onMerged={(cigar) => {
          // TODO Update the cigar details in the list?
          handleRowDelete(state.selectedCigar);
          updateState({ selectedCigar: null, showMergeModal: false });
        }}
      />
      {renderBrandPicker()}
    </div>
  );
};

const mapStateToProps = ({ CigarManager }: any) => ({ CigarManager });

export default connect(mapStateToProps, {
  getAllCigars,
  getDuplicateCigars,
  searchCigars,
  getCigarById,
  getBrands,
  getManufacturers,
  getOrigins,
  getWrappers,
  getBinders,
  getFillers,
  updateVitolas,
})(CigarTable);
